var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74761 7.50012L14.7413 1.50637C15.0862 1.16137 15.0862 0.603743 14.7413 0.258747C14.3963 -0.086249 13.8386 -0.086249 13.4937 0.258747L7.50001 6.2525L1.50634 0.258747C1.16135 -0.086249 0.603732 -0.086249 0.258742 0.258747C-0.0862475 0.603743 -0.0862475 1.16137 0.258742 1.50637L6.25239 7.50012L0.258742 13.4939C-0.0862475 13.8389 -0.0862475 14.3965 0.258742 14.7415C0.430798 14.9135 0.65667 15 0.882542 15C1.10841 15 1.33429 14.9135 1.50634 14.7415L7.49998 8.74774L13.4936 14.7415C13.6657 14.9135 13.8916 15 14.1174 15C14.3433 15 14.5692 14.9135 14.7412 14.7415C15.0862 14.3965 15.0862 13.8389 14.7412 13.4939L8.74761 7.50012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a5b48797fbaf55f587215f8cae1dd66a.svg";
export { ForwardRef as ReactComponent };